<template>
  <div ref="shareContainer" class="mt-2 relative">
    <div @click="handleClick()">
      <OIcon
        icon="article/share"
        class="rounded-full u-center cursor-pointer overflow-hidden bg-white text-primary-200 border border-[#E2E5ED] w-11 h-11 p-2"
        :aria-label="$t('main.breadcrumbRoot')"
      />
    </div>
    <div class="flex justify-center mt-2 flex-col" :class="isClick ? 'showicons' : 'hidden'">
      <span class="font-semibold text-13">{{ $t('main.share') }}</span>
      <SocialButton v-for="item in stickyButtons" :key="item" :article="article" :button-type="item" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import SocialButton from './SocialButton';
import { useOutsideClick } from '~/composables/useOutsideClick';
import { OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  components: { OIcon, SocialButton },
  props: {
    article: {
      type: Object,
      require: true,
    },
  },
  setup() {
    const { sendDetayInteractionEvent } = onedioEvents();
    const stickyButtons = ['facebook', 'twitter', 'whatsapp', 'telegram', 'google', 'copy'];
    const isClick = ref(false);
    const shareContainer = ref();

    const showPageUpButton = () => {
      const element = document.getElementById('pageUpButton');
      if (element) {
        element.style.display = isClick.value ? 'none' : 'flex';
      }
    };

    const handleClick = () => {
      sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Paylaş');
      isClick.value = !isClick.value;
      showPageUpButton();
    };

    useOutsideClick(shareContainer, () => {
      if (isClick.value) isClick.value = false;
      showPageUpButton();
    });

    const getScrollGap = () => {
      const h = document.documentElement;
      const currentScrollTop = h.scrollTop;
      if (currentScrollTop - 10 < h.scrollTop && !isClick.value) {
        showPageUpButton();
        return false;
      }
    };

    const toggleVisibility = throttle(() => {
      isClick.value = getScrollGap();
    }, 100);

    onMounted(() => {
      window.addEventListener('scroll', toggleVisibility);
    });

    return { isClick, handleClick, stickyButtons, shareContainer };
  },
});
</script>

<style lang="scss">
.showicons {
  animation: fadeIn 0.6s ease-in;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 100;
    }
  }
}
</style>
